import { fromCents } from '@ankor-io/common/domain/pay/currency'
import { type CharterStatsPayload, type CharterSummary as CharterSummaryType } from '@ankor-io/common/types/charter'
import { formatCurrency } from '@ankor-io/common/util/currencies'

import { Heading } from '@/ui-components/Heading'

type CharterSummaryProps = {
  charter: CharterSummaryType
  stats: CharterStatsPayload
}

const CharterSummary = ({ charter, stats }: CharterSummaryProps) => {
  return (
    <>
      <div className="space-y-6 rounded-lg p-4 sm:p-6 border border-gray-200 dark:border-gray-700">
        <div className="flex flex-col">
          <Heading level={6}>Fund allocation and budget tracking</Heading>
        </div>

        {/* Budget Overview */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div className="text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">Currency</p>
            <p className="text-xl font-bold text-primary-900 dark:text-primary-300">{charter.currencyCode}</p>
          </div>
          <div className="text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">Contracted APA Amount</p>
            <p className="text-xl font-bold text-primary-900 dark:text-primary-300">
              {formatCurrency(fromCents(charter.apaCents), charter.currencyCode)}
            </p>
          </div>
          {/* TODO: Replace hardcoded value 0 */}
          <div className="text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">APA Funds Received</p>
            <p className="text-xl font-bold text-primary-900 dark:text-primary-300">
              {formatCurrency(0, charter.currencyCode)}
            </p>
          </div>
          <div className="text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">Expenses Ready to Review</p>
            <p className="text-xl font-bold text-primary-900 dark:text-primary-300">
              {stats.nonReviewedTransactionsCount}
            </p>
          </div>
          <div className="text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">APA Amount Spent</p>
            <p className="text-xl font-bold text-orange-600 dark:text-orange-400">
              {formatCurrency(fromCents(stats.apaSpentCents), charter.currencyCode)}
            </p>
          </div>
          <div className="text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">APA Remaining</p>
            <p
              className={`text-xl font-bold ${stats.apaRemainingCents >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}
            >
              {formatCurrency(fromCents(stats.apaRemainingCents), charter.currencyCode)}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default CharterSummary
